import { HomeComponent } from '../../components/common/HomeComponent';

export const HomeContainer: React.FC = () => {
  return <HomeComponent />;
};
